import React from "react";
import LocationSection from "../LocationSection";

const LocationPage = () => {
    window.scroll(0,0);
    return(
        <>
            <LocationSection/>
        </>
    );
}
export default LocationPage;